import { render } from "./Statistique.vue?vue&type=template&id=2074afe7&scoped=true"
import script from "./Statistique.vue?vue&type=script&lang=js"
export * from "./Statistique.vue?vue&type=script&lang=js"

import "./Statistique.vue?vue&type=style&index=0&id=2074afe7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2074afe7"]])

export default __exports__